import { AIChatTurn } from "../store/@types/ai";
import { IChatMessage } from "../store/@types/chat";

export const INITIAL_MESSAGES: IChatMessage[] = [
  {
    id: "intro",
    role: "assistant",
    content:
      "Hi — I'm the Elite Corporate Setup assistant. Ask me about company registration, compliance, our plans, or how to use this site. You can type, or tap the phone icon for a live voice call.",
  },
];

export const toHistory = (messages: IChatMessage[]): AIChatTurn[] =>
  messages
    .filter((message) => message.id !== "intro")
    .map((message) => ({
      role: message.role === "assistant" ? "model" : "user",
      text: message.content,
    }));
